import { createSlice } from '@reduxjs/toolkit';

import * as clientApi from '../services/clientApi';

export const clientsSlice = createSlice({
  name: 'clientsList',
  initialState: [],
  reducers: {
    set: (_, action) => action.payload,
    add: (clients, action) => [...clients, action.payload],
    remove: (clients, action) => clients.filter(c => c.id !== action.payload),
    change: (clients, { payload: { id, ...client } }) =>
      clients.map(c => (c.id !== id ? c : { ...c, ...client })),
  },
});

export const { set, add, remove, change } = clientsSlice.actions;

export default clientsSlice.reducer;
